/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/archive-product.js":
/*!***********************************!*\
  !*** ./src/js/archive-product.js ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _archive_product_accordion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./archive-product/accordion */ \"./src/js/archive-product/accordion.js\");\n\n\nwindow.addEventListener('DOMContentLoaded', function () {\n  (0,_archive_product_accordion__WEBPACK_IMPORTED_MODULE_0__[\"default\"])()\n})\n\n\n//# sourceURL=webpack://troispilier/./src/js/archive-product.js?");

/***/ }),

/***/ "./src/js/archive-product/accordion.js":
/*!*********************************************!*\
  !*** ./src/js/archive-product/accordion.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"default\": () => (__WEBPACK_DEFAULT_EXPORT__)\n/* harmony export */ });\nfunction accordion() {\n  const tabBoxes = document.querySelectorAll('.js-menu1');\n  const tabContents = document.querySelectorAll('.js-menu-item1');\n  const tabs = document.querySelectorAll('.js-menu-trigger1');\n\n  // 初期化\n  tabContents.forEach(content => {\n    content.style.maxHeight = '0px';\n    content.classList.remove('is-open');\n  });\n\n  tabs.forEach((tab, index) => {\n    // aria属性の設定\n    tab.setAttribute('aria-expanded', 'false');\n    tab.setAttribute('role', 'button');\n    \n    tab.addEventListener('click', (event) => {\n      // クリックがactive-facets内で発生した場合は処理を中断\n      if (event.target.closest('.active-facets__button')) {\n        return;\n      }\n\n      // アコーディオンのトグル処理\n      const isOpen = tabContents[index].style.maxHeight !== '0px';\n      \n      // 全てのタブを閉じる\n      tabContents.forEach((content, i) => {\n        content.style.maxHeight = '0px';\n        tabs[i].classList.remove('is-open');\n        content.classList.remove('is-open');\n        tabBoxes[i].classList.remove('is-open');\n        tabs[i].setAttribute('aria-expanded', 'false');\n      });\n\n      if (!isOpen) {\n        // クリックされたタブを開く\n        const content = tabContents[index];\n        const innerHeight = content.querySelector('.js-menu-item-contents').scrollHeight;\n        content.style.maxHeight = `${innerHeight}px`;\n        tabs[index].classList.add('is-open');\n        content.classList.add('is-open');\n        tabBoxes[index].classList.add('is-open');\n        tabs[index].setAttribute('aria-expanded', 'true');\n      }\n    });\n  });\n}\n\n/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (accordion);\n\n\n//# sourceURL=webpack://troispilier/./src/js/archive-product/accordion.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/js/archive-product.js");
/******/ 	
/******/ })()
;